import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import DefinitionSection from '~common/form/definition-section';
import {Definition} from '~common/lib/types';
import { APIError } from '~common/lib/types';

import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {SummaryAction} from '~common/components/query-fulfillment/query-list';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from '@mui/material';
import {setValueAtPathWithOpts} from '~common/form/helper';

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden'
  },
  modalContent: {
    minHeight:300, 
    minWidth:"70%"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  title: string;
  action: any;
  items: Array<any>;
  // formSelector is the form that will be presented to the user if the summary action is selected.
  // Ignored if onClick is provided
  formSelector: any;

  // onFormComplete is called when the form is completed by the user.  
  // `done` is called with the action is complete to dismiss the modal and trigger and update of the results list automatically.
  onFormComplete: (items:Array<any>, action:SummaryAction, formData:any, cancelled: boolean, done:Function) => void;

  // allow one to override the props for the compelte button.  `label` will be used as the prop for the button text 
  formCompleteButtonProps?: any;

  // allow one to override the props for the cancel button.  `label` will be used as the prop for the button text 
  formCancelButtonProps?: any;

  // policyMessages allows the top-level consumer to inject messages into the form.
  policyMessages?: any;


  // Custom messages to be provided to the form
  customRenderers?: any;

  // Custom messages to be provided to the form
  customMessages?: any;

  // Grid Spacing is the spacing for the grid that will be honored in the form.  Will default to 8
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 

}

type State = {
  status: 'loading' | 'ready' | 'error';
  form?: any;
  data: any;
  error?: any;
};

class SummaryDialogForm extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'ready',
      data: {}
    };
  }

 componentDidMount() {
    this.handleProps(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps: any) {
    this.handleProps(newProps);
  }

  handleChangeAtPath = (path: string, value: any) => {
    let {data, err} = setValueAtPathWithOpts(path, this.state.data, value, {
      emptyAsNull: true
    });
    if (err) {
      const apiErr = new APIError();
      apiErr.message = err;
      this.setState({
        error: apiErr
      });
    } else {
      this.setState({
        data: data
      });
    }
  };

  handleProps(props: any) {
    var {
      form,
      formSelector
    } = props;
    //var {currentPage, criteria} = this.state
    var newState: State = this.state;

    if(form){
      newState.form = new Definition(form)
      this.setState(newState)
    } else {

      this.setState({status:"loading"}, ()=>{
        request.get(
          '/api/form-definitions/select?selector=' + JSON.stringify(formSelector)
        )
        .then((response) => {

          // If provided an actual form, we will just use it
          newState.form = new Definition(new Definition(response.body));
          newState.status = "ready"
          this.setState(newState)

        })
        .catch((err) => {
          const apiErr = new APIError();
          apiErr.type = 'http';
          apiErr.message = 'Error fetching data during initialization';
          apiErr.details = (err.response || {text: err.toString()}).text;
          this.setState({
            status: 'error',
            error: apiErr
          });
        });
      })
    }
  }

  handleDialogClose = () => {

    const cb = (policyMessages:Array<any>) => {

    }

    // console.log("handleDialogClose")

    if(this.props.onFormComplete) {
      this.props.onFormComplete(this.props.items, this.props.action, this.state.data, true , cb);
    }
  }

  handleCancel = () => {
    // console.log("handleCancel")

    const cb = (policyMessages:Array<any>) => {
      // console.log(policyMessages)
    }

    if(this.props.onFormComplete) {
      this.props.onFormComplete(this.props.items, this.props.action, this.state.data, true , cb);
    }

  }

  handleComplete = () => {
    // console.log("handleComplete")

    const cb = (policyMessages:Array<any>) => {
      // console.log(policyMessages)
    }

    if(this.props.onFormComplete) {
      this.props.onFormComplete(this.props.items, this.props.action, this.state.data, false , cb);
    }

  }



  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {title, policyMessages, customRenderers, customMessages, gridSpacing} = this.props;
    const {status, data, form} = this.state;

    switch (status) {
      case 'loading':
        return (
          <div className={classes.container}>
            <LoadingView classes={
              {}
            } />
          </div>
        );
      default:

        return (
            <Dialog
                className={classes.modal}
                open={true}
                onClose={this.handleDialogClose}
            >   
                <DialogTitle>{title}</DialogTitle>
                <DialogContent style={{}} className={classes.modalContent}>
                    <div>
                      <DefinitionSection
                        data={data}
                        definition={form}
                        path={''}
                        onChangeAtPath={this.handleChangeAtPath}
                        policyMessages={policyMessages}
                        gridSpacing={gridSpacing || 1}
                        customRenderers={customRenderers}
                        customMessages={customMessages}
                        embedded={true}
                        suppressTitle
                        supressSectionStatusIcon={true}
                      />
                    </div> 
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="contained"
                        onClick={this.handleCancel}
                        color="inherit">
                        Cancel
                    </Button>
                    <Button 
                        autoFocus={true}
                        onClick={this.handleComplete}
                        variant="contained"
                        color="secondary">
                        Complete 
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
  }
}

export default withStyles(styles)(SummaryDialogForm);




